module.exports = __webpack_public_path__ + "assets/img/media_28.073bfb23.png";